// @ts-nocheck
import React from 'react';

function JaJpContent() {
  return (
    <div id="agreement_container">
      <div style={{ padding: '1% 5% 0 5%' }}>
        <p style={{ fontSize: '18px', fontFamily: 'Georgia, "Times New Roman", Times, serif', textAlign: 'center' }}>
          <b>使用許諾契約</b>
        </p>
        <p style={{ fontSize: '14px', fontFamily: '"georgia"' }}>
          <b>はじめに </b>
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          GlobalEnglishサービスのウェブサイト/モバイルアプリケーション（まとめて「サービス」と言う）へようこそ。
          <br />
          <br />{' '}
          当社のサービスは、ウェブサイトおよびモバイルアプリケーションを介して生成された、またはアクセス可能なデータ、テキスト、オンラインテスト、デザイン、ビデオ、オーディオクリップ、音声録音、書面の投稿とコメント、スクリプト、グラフィック、画像、それらのセレクションとアレンジメント、ソフトウェア、チュートリアル、クラス、コーチング、トレーニング、コミュニケーション、インタラクティブ機能（まとめて「コンテンツ」と言う）を含むがこれに限定されない英語学習ツールとオンラインソリューションです。当社のウェブサイトにアクセスして、当社についてをお読みいただき、サービスの一環と見なされる当サービスについてご確認ください。
          <br />
          <br />
          以下を細部までお読みいただき、続ける前に使用条件をご理解いただき同意されることをご確認ください。
          <br />
          <br />
          <b>
            あなたが18歳未満の場合は、本使用許諾契約を保護者とお読みいただき、当社サービス使用前に彼らの同意を得てください。当社サービスをご利用いただくことは、あなたが18歳以上であり、または保護者の同意を得ており、GLOBALENGLISHと本契約を締結できることを示しています。
          </b>
        </p>
        <p style={{ fontSize: '14px', fontFamily: '"georgia"', textAlign: 'center', width: '100%' }}>
          <b>一般条項 </b>
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}> 1. 法的拘束力のある契約 </b>
          <br />
          <br />
          <b>
            {' '}
            あなたが当社ウェブサイトにアクセスし、GLOBALENGLISHのサービスを利用することは、以下の使用許諾契約、プライバシーポリシー、クッキーポリシー（これら3つの文書をまとめて「使用条件」と言う）の対象となります。GLOBALENGLISHのサービスにアクセス、訪問、登録、および/または利用することは、あなたが当社サービスの使用条件を読み、かつ理解し、本契約には取消不能な法的拘束力があることに同意し、GLOBALENGLISHと法的拘束力のある契約を締結することを示しています。
          </b>
          <br />
          <br /> 当社ポリシーの概要は
          <a
            href="https://globalenglish.com/company/about-us/legal/globalenglish-privacy-statement/"
            rel="noopener noreferrer"
            target="_blank"
          >
            こちら
          </a>
          でご確認ください。これらのポリシーは「使用許諾契約」または「契約」および両方を参照することにより盛り込まれており、これらが使用条件を形成しています。
          <br />
          <br />
          <b>
            本契約には、互いに申し立てがあった場合に解決する方法についての条項も含まれていることにご留意ください。特に、以下の「保証の免責」、「責任制限」、「訴訟」の条項をご覧ください。また、限定的な例外のある、あなたが提出した申し立てに対する拘束力のある最終的仲裁を要する仲裁についての規定も含まれます。あなたはクラス内の原告またはクラスのメンバーや訴訟の代表としてではなく、個人としてのみ訴訟することができます。あなたは個人としてのみ救済（金銭、差し留めによる救済）を求めることができます。
            <br />
            <br />
            いつであっても本契約のいずれかの部分に合意しない場合は、当サービスを使用してはならず、これ以上当社ウェブサイトを利用することはお控えください。
          </b>
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>2. 適用性 </b>
          <br />
          <br />{' '}
          本契約は当社サービスのユーザーと当社サイトへの訪問者の両方に適用されます。試用であっても、当社に直接登録する人（
          <b>「B2C トランザクション」</b>）および雇用者が登録した人（
          <b>「B2B トランザクション」</b>）を、
          <b>「ユーザー」</b>と言い、当社ウェブサイトを利用する未登録のユーザーおよび訪問者を
          <b>「訪問者」</b>と言います。
          <b>「ユーザー」</b>
          という用語には、GlobalEnglishサイトにアクセスして他のユーザーにサービスを提供する教師、コーチ、学習スペシャリスト、その他の人も含まれます。ユーザーと訪問者の両方を「あなた」と言います。
          <br />
          <br /> 本契約はすべてのGlobalEnglishのサービスに適用されます。
          <br />
          <br />{' '}
          あなたがユーザーとして初めて登録し、当サービスにアクセスする際、当社はボックスの「同意します」をクリックしていただくか、あなたの電子署名またはその他の認証手段をご提供いただくことで、使用条件に同意していることの確認を再度行う場合があります。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>3.使用条件の変更 </b>
          <br />
          <br />
          GlobalEnglishは、あなたのサービスの使用に適用される本契約、クッキーポリシー、プライバシーポリシーを含むいつでも使用条件を変更することができます。かかる変更は、当サービス内への投稿、サービスアカウント（該当する場合）または他の手段に関してあなたが提供したメールアドレスへの電子メッセージによる通告により直ちに有効となります。当サービスへあなたの雇用主または会社を通して登録した場合、あなたの雇用主または会社が当社の使用条件の変更を通知することができます。
          <br />
          <br />{' '}
          これらの変更に反対する場合は、アカウントを閉めて当社ウェブサイトにアクセスすることをやめてください。しかし、当社が本契約への変更を発表または送付した後にも当サービスの利用を続ける場合は、使用条件への変更をあなたが許諾したとみなされます。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>4. 第三者の使用条件 </b>
          <br />
          <br />
          当サービスは、他のウェブサイト（「第三者のサイト」）へのリンクと、第三者に属する、または第三者から取得した記事、写真、テキスト、翻訳、グラフィック、絵、デザイン、音、ビデオ、情報、その他のコンテンツ（「第三者のコンテンツ」）を含む場合があります。当社はかかる第三者のサイトおよび第三者のコンテンツの正確性、適切性、または完全性を調査、監視、または確認することはなく、当社ウェブサイト経由でアクセスされる第三者のサイトまたはウェブサイトに投稿された、または提供される第三者のコンテンツの責任を負いません。
          <br />
          第三者のサイトまたは第三者のコンテンツへのリンクまたはその使用の許可を含んでいても、GlobalEnglishがこれを承認または保証することを暗示していません。GlobalEnglishは、これらのリンクをいつでも通知なしに終了する権利を保有します。会社、組織、製品またはサービスを当サービスで紹介しても、GlobalEnglishがそれらを保証、後援、または推奨することや同盟関係を持つことを意味または示唆していません。
          <br />
          <br />{' '}
          当社ウェブサイトを離れて第三者のサイトにアクセスする、または第三者のコンテンツを使用することを決めた場合、ご自身のリスクで行い、当社の使用条件はかかる第三者のサイトの利用をもはや管理していないことにご注意くださいご利用の前に、第三者の他の製品やサービスに適用される条件やポリシーを必ずご確認ください。
          <br />
          <br /> 当社はAndroid MarketとiTunes
          Store（まとめて、これらを維持する組織とともに「プロバイダー」と言う）の両方でモバイルアプリケーションを提供しています。これらのモバイルアプリをお使いになると、アプリストアの使用条件に記載のご利用規則等の、プロバイダーの使用条件の対象となります。いずれかのモバイルアプリをiTunes
          Storeでダウンロードした場合、あなたはアプリストアの使用条件を読み合意していることを認識しこれに同意します。いずれかのモバイルアプリをAndroid
          Marketストアでダウンロードした場合、あなたはAndroid
          Marketの使用条件を読み合意していることを認識しこれに同意します。プロバイダーには、あなたがサービスを使用することに関してメンテナンスやサポートサービスを提供する義務はなく、提供することもありません。プロバイダーはいかなる種類のサービスであっても保証しません。何らかのモバイルアプリが適用保証内容に適合せず、このアプリがiTunes
          Storeでダウンロードしたものである場合、Appleに知らせてください。Appleがかかるアプリの購入金額（有料の場合）を返金します。本契約はすべてモバイルアプリと当社の他のサービスをあなたが使用することに適用されます。
          <br />
          <br /> あなたは、GlobalEnglishがこれらの第三者のウェブサイトまたはアプリケーションの
          コンテンツ、製品、サービスまたは性能に責任を負わず保証しないことを認識しこれに同意します。あなたは、第三者のウェブサイトまたはアプリケーションに関してGlobalEnglishに対して申し立てをする権利を取り消し不能で放棄します。特に、GlobalEnglishはクッキー、ウェブベーコン、クリアGIF、またはあなたまたは他者があなたのコンピュータに何らかの方法で追加したその他のコードについて、かかるコードとウェブサイトコンテンツの関係性も含め、一切責任を負いません。例えば、あなたが当ウェブサイトのリンクから第三者のサイトにアクセスする場合、お使いのブラウザまたはコンピュータの他クッキーが閲覧履歴を示すサイトやリンクの元であるURLを送信するためのリファラヘッダーを生成する場合があります。GlobalEnglishは、かかる送信に関して、送信がGlobalEnglishに関する情報を含む、またはGlobalEnglishから送信されたものであるなしに関わらず、一切責任を負いません。
          <br />
          <br />{' '}
          Google翻訳を使用する場合：Googleは翻訳に関して、正確さ、信頼性の保証、商業性、特定の目的に対する適格性、および非侵害の暗黙の保証を含む、明示的または暗示的なすべてにおいて一切保証しません。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>5. サービス適格基準 </b>
          <br />
          <br />
          <b>5.1 当社サービス使用における子どものプライバシー保護および制限 </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            当サービスは、当サービスにアクセスしている国における最低年齢に達していない人に向けたものではありません。例えば、欧州連合、欧州経済領域およびスイスにおける「最低年齢」とは、特定の国の法律に規定されていない限りは、16歳です。米国では、最低年齢は13歳です。最低年齢に達していない何者かがサービスに登録、使用、アクセスすることは禁じられており、本契約の違反となります。
            <br />
            <br /> サービスを使用すると、ご自身が13歳以上であることを示し保証することになります。
          </span>
          <br />
          <br />
          <b>5.2 学校および教師 </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            13歳未満の生徒のためにGlobalEnglishアカウントの作成を望む米国内の学校、地区または教師は、米国児童オンライン保護法（「COPPA」）と、適用される範囲で、家族教育権およプライバシー保護法（「FERPA」）を順守する責任があります。つまり、学校、地区または教師は、学生の保護者にGlobalEnglishが個人識別情報を収集することを知らせ、学生がアカウントを作りサービスを利用する前に保護者の同意を必ず得てください。同意を得る際に、学校、地区または教師は、必ず保護者にプライバシーポリシーの写しを提供し、すべての同意を記録し、当社が要望した際はそれを当社にご提供ください。COPPA,の順守についての詳細は、
            <a
              style={{ textDecoration: 'underline' }}
              href="https://www.ftc.gov/tips-advice/business-center/guidance/complying-coppa-frequently-asked-questions"
              rel="noopener noreferrer"
              target="_blank"
            >
              Federal Trade Commissionのウェブサイト
            </a>
            をご覧ください。
            <br />
            <br />{' '}
            あなたが米国外にいる場合は、類似の法律の対象となる学生の保護者から必要な同意または承認を得ていただくようお願いします。あなたの、およびあなたの生徒が当サービスを使用する場合の条件として、あなたはかかる法律を順守する責任を負います。
          </span>
          <br />
          <br />
          <b>5.3 保護者の同意</b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            <b>
              当社サービスをご利用いただくことは、あなたが18歳以上であり、または保護者の同意を得ており、GLOBALENGLISHと本契約を締結できることを示しています。
              <br />
              <br />{' '}
              子どもが利用する場合、当社は、子どもの保護者および/または権限のある学校職員の指導、監督、同意のもとにのみ利用されることを予想しています。GlobalEnglishは、未成年が当サービスを使用する際は、保護者、学校に使用条件に記載の彼らの権利と責任を理解していることを確認していただきます。
              <br />
              <br />{' '}
              GlobalEnglishは、単独の裁量で当サービスを個人または団体に提供することを拒否し、適格基準をいつでも変更できます。{' '}
            </b>
          </span>
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>6.プライバシー </b>
          <br />
          <br />
          <b>6.1 プライバシーステートメント </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            プライバシーポリシーを
            <a
              href="https://globalenglish.com/company/about-us/legal/globalenglish-privacy-statement/"
              rel="noopener noreferrer"
              target="_blank"
            >
              こちら
            </a>
            でご確認ください。
            <br />
            <br />{' '}
            当社はあなたが当サービスに初めてアクセスするときにあなたが同意したプライバシーポリシーに従って、またはプライバシーポリシーの予定された更新の一環として、個人データを処理します。
          </span>
          <br />
          <br />
          <b>6.2 あなたの提供するデータ </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            {' '}
            当サービスを使用するために、あなたは有効なアカウントを持っている必要があります。当サービスに登録するためには、GlobalEnglishにユーザーID、メールアドレス、個人を識別可能な情報と考えられる他の情報（「個人データ」）をご提供いただく必要があります。あなたから収集する情報には、GlobalEnglishがサービスを提供する上で、または単にあなたがサービスに関して質問したことに関しての情報を返信するために必要なものがいくつかありますが、他については選択式です。当サービスでは、あなたは自分自身と所属組織（該当する場合）の情報を表示することができます。
            <br />
            <br /> あなたは以下に同意します。(I)
            当サービス内のフォームで指示される通り、あなた、かつB2Bトランザクションの場合、あなたの組織についての正確で、現在のもので完全な情報を提供すること。(ii)
            あなたのパスワードとあなたのアカウントのセキュリティに関する情報の秘密を守ること。(iii)
            あなたがGlobalEnglishにご提供いただいた個人データと他の情報をメンテナンスし遅延なく更新し、かかる情報が正確で、現在のもので完全である状態に保つこと。および
            (iv) あなたのアカウントの使用とあなたのアカウントを介して取られるすべての行為の責任を完全に負うこと。
            <br />
            <br /> GlobalEnglishには、あなたが登録のためにご提供いただいた個人データの正確性を検証する義務はありません。
          </span>
          <br />
          <br />
          <b>6.3 個人データの国際送受信 </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            当サービスを提供するために、GlobalEnglishは世界中で雇用をしており、第三者ベンダーとストレージのホスティングパートナーならびに他の技術関連および教育サービスを利用しています。このためあなたの個人データは様々な国にいるGlobalEnglishの従業員や下請業者により処理され、また送受信され、国によってはあなたが市民権を持つ/居住する国での法的な個人データ保護と同レベルの対応をしていない所もあります。
            <b>
              当サービスにアクセス、登録および/またはこれを使用すれば、あなたは自分の個人データがGlobalEnglish、関係会社および下請業者がある様々な国へ当サービスの目的で送られ処理されることに同意したことになります。
            </b>
          </span>
          <br />
          <br />
          <b>6.4 通知およびメッセージ </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            あなたは、当サービスには、サービスアナウンスメント、管理メッセージなどのGlobalEnglishからのコミュニケーションが含まれ、これらのコミュニケーションは当サービスの一環と見なされ、これを受信しないよう設定できないことを理解し同意します。
            <br />
            <br /> あなたはここに、GlobalEnglishは次の方法で通知やメッセージをご提供する場合があることを同意します。(I)
            当サービス内で、(ii)
            GlobalEnglishにご提供いただいた連絡先情報へ（電子メールまたは携帯電話番号）。あなたは、いつでも連絡先情報を最新のものに維持することを同意します。
          </span>
          <br />
          <br />
          <b>6.5 他者のプライバシー </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            当サービスを使った結果、他のユーザーについての情報をあなたが得た場合、あなたはこの情報をあなたに提供された目的のみに使用することに同意します。あなたはユーザーの情報を当サービスと無関係な目的のために第三者へ開示、販売、配布してはなりません。特定のユーザーからの同意を得ない限り、マーケティングのために情報を使用してはなりません。
          </span>
          <br />
          <br />
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>7. ユーザーライセンス </b>
          <br />
          <br />
          <b>7.1 当社サービス使用のライセンス </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            あなたには、非商業的で個人的な使用にのみ、限定的な、個人の、非独占的な、譲渡不能な、サブライセンス不能な当サービスのアクセスおよび使用ライセンスが付与されます。GlobalEnglishは、独断の裁量で当サービスを一時的または永久的に廃止する、または事前の通知なしでその時々で当サービスの機能を変更する場合があります。
            <br />
            <br />{' '}
            当サービスを利用するために、あなたは直接、またはウェブベースコンテンツにアクセスするデバイスを使ってのいずれかで、World
            Wide Webにアクセスする必要があります。また、コンピュータとモデム、または他のアクセスデバイスなどの、World
            Wide
            Webに接続するために必要な機器をすべて持っている必要があります。あなたは、提供するコンテンツの正確さ、完全さ、または利便性における信頼性を含む、当サービス使用に関するすべてのリスクを評価し引き受ける必要があります。GlobalEnglishとライセンス付与者のいずれもコンテンツの正確さまたは完全性を保証しません。
            <br />
            <br />{' '}
            当サービスは危険な環境（運転中、水辺で、など）で使用するために作られたものでもライセンス付与されたものでもありません。
            <br />
            <br />
            当サービスの使用が禁じられている、または当サービスの供与、販売または提供の範囲で適用法、規則、規定に対立する場合は、当サービスにアクセスする権利は破棄されます。
            <br />
            <br />
            使用条件で予定されている以外の目的で当サービスを利用することはGlobalEnglishのおよび/またはライセンサーと委託先の著作権および所有権の使用条件違反となります。GlobalEnglishが当サービスの使用があなたの使用条件の違反になると察する合理的な理由がある場合は、GlobalEnglishは、あなたのアカウントを保留または解除し、現在または将来的なサービスを提供することを拒否する権利を持ちます。あなたは、GlobalEnglishが当サービスまたはその一部の変更、保留または廃止について保証しないことに同意します。
          </span>
          <br />
          <br />
          <b>7.2 ユーザーコンテンツ</b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            {' '}
            当サービスではあなたと他のユーザーはデータと情報を作り（他の試験への回答を提供する、など）、コミュニティベースサービスに素材をアップロードすることができます（「ユーザーコンテンツ」）。本契約の当社の権利として、あなたはユーザーコンテンツの所有権をすべて保持します。
            <br />
            <br />{' '}
            当サービスに何らかのユーザーコンテンツをアップロードすれば、あなたは当サービスの条件に関連して必要な場合はユーザーコンテンツを保存、使用、複製、公共的な実施、公共的な展示、変更、翻訳、（全部または一部の）抜粋、加工および配布するために、取り消し不能の、永久的な、非独占的な、譲渡可能な、完全に支払われた、世界規模のライセンスを、以下のためにGlobalEnglishに与えることになります。
            <br />
            <br />
            <span style={{ padding: '0 2% 0 2%', display: 'inline-block' }}>
              (a) 法的要件、司法命令、その他類似の政府の要望に応えることに限らず、順守すること。
              <br />
              (b) 契約書を有効にすること。
              <br />
              (c) コンテンツが第三者の権利に違反するという申し立てに返答すること。
              <br />
              (d) GlobalEnglishの権利、所有物、個人の安全、その従業員、ユーザーと公共を保護すること。
            </span>
            <br />
            <br />{' '}
            あなたがユーザーコンテンツを当サービスの他のユーザーに共有することを選ぶ場合は、あなたは、そのユーザーがあなたのユーザーコンテンツを閲覧することを許可し、適用される場合は、ユーザーコンテンツにおいてあなたと協力することを許可することに同意します。
            <br />
            <br />
            GlobalEnglishにはいつであっても、かかるユーザーコンテンツを審査、確認、検査する義務はないことにご注意ください。しかし、ユーザーコンテンツを監視し、絶対裁量において、不快なものや使用条件違反と考えられるものは削除する権利を留保します。
            <br />
            <br />{' '}
            GlobalEnglishは、ユーザーコンテンツをバックアップまたは保存する義務を負いません。あなたにはバックアップコピーを作成し当ウェブサイトに投稿または保存した、またはGlobalEnglishに提供したユーザーコンテンツを取り替える際の費用および経費を単独で負う責任があります。
            <br />
            <br />
            ユーザーコンテンツは必ずしもGlobalEnglishの見方を反映するものではありません。あなたは、ユーザーコンテンツにはユーザーコンテンツを元々発生したユーザーが単独で責任を負うことを理解します。あなたは、当サービスを使用すれば、悪意のある、不快、わいせつ、または問題があるコンテンツに出くわす場合があること理解します。
            <br />
            <br />{' '}
            上記のユーザーコンテンツへのライセンス付与に加えて、あなたは、あなたがGlobalEnglishに提供した当サービスに関する質問、コメント、提言、アイデア、フィードバック、またはその他情報（「提出」）は、秘密ではなく、どのような目的商業用途であっても、あなたに知らせることまたは補償することなしに、GlobalEnglishは提出を無制限に使用し留保する権利を持つことを認め、同意します。またあなたがGlobalEnglishのコミュニティベースのサービスまたは製品において、またはこれにより投稿、開示、共有した情報は、通常定義される用語通りに、機密情報の定義からは外れます。
            <br />
            <br /> あなたは、あなたのユーザーコンテンツを含む、ウェブサイトの技術処理および送信に、(a)
            各種ネットワークを介した送信、および (b)
            接続ネットワークまたはデバイスの技術要件に適応および適合させるための変更が含まれる場合があることを理解します。
            <br />
            <br />
            <b>
              GlobalEnglishは、ユーザーコンテンツに関して一切の保証責任を負いません。ユーザーコンテンツは必ずしもGlobalEnglishの見方を反映するものではありません。GlobalEnglishは、何らかの理由または使用または損失に起因する申し立て、損害または損失に対する、ユーザーコンテンツやそれらの損失には一切責任を負いません。
            </b>
          </span>
          <br />
          <br />
          <b>7.3 必要なユーザーの行為</b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            {' '}
            あなたは、あなたのアカウントのもとで行われたすべての行為の責任を完全に負います。あなたは、以下に同意します。
            <br />
            <br />
            <span style={{ padding: '0 2% 0 2%', display: 'inline-block' }}>
              (a)
              あなたのアカウントが不正に使われた、またはセキュリティ違反があった場合に直ちにGlobalEnglishに知らせること、および
              <br />
              (b) 各セッションの最後にはあなたのアカウントから必ずログアウトすること。
            </span>
            <br />
            <br />
            GlobalEnglishは、あなたが約束違反したことによる損失または損害に関して責任を負うことはできず、かつ責任を負うことはありません。
            <br />
            <br />
            あなたは、これらのサービス条件が適用されるすべての法律、規則、規制に準拠しており、本サービス条件または当サービスの使用が禁止されているまたは当サービスの供与、販売または提供の範囲で適用法、規則、規定に対立する場合は、当サービスにアクセスする権利は破棄されることを確認したことに単独で責任を負います。
          </span>
          <br />
          <br />
          <b>7.4 禁止されたユーザーの行為 </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            以下は違法であるかGlobalEnglishが禁止した使用例です。GlobalEnglishは、本条件に違反するものに対して、GlobalEnglishの単独の裁量で、調査し該当する法的措置を取る権利を留保し、これにはウェブサイトまたはアプリケーションからの不快なコンテンツの削除、かかるユーザーのアカウントの保留または解除、およびあなたを法的執行機関に報告することを含むがこれに限定されない行為を含みます。
            <br />
            <br /> あなたは、以下を行ってはなりません。
            <br />
            <span style={{ padding: '0 2% 0 2%', display: 'inline-block' }}>
              (a)
              GlobalEnglishによる特別な許可を受けていない場合の、GlobalEnglishのコンテンツまたは当サービスの他の素材の適用、ダウンロード、変更、放送、リバースエンジニアリング、複製、発行、改造、発信、展示、転送、複写及および/または配布。
              <br />
              (b) 当サービスの一部を含めるためのフレームまたはフレーミング技術の使用。
              <br />
              (c)
              ボット、スパイダー、クロウラー、スパイウェア、エンジン、デバイス、ソフトウェアまたは他の自動デバイス、ユーティリティまたは手動処理を使用した当サービスの一部の収集、取得、使用、アクセスまたは複写。
              <br />
              (d)当サービスを中断、損傷、無効化、過負荷、または使用不可にする方法での当
              サービスまたは当サービスで利用可能な機能の使用。
              <br />
              (e) 商業目的での当サービスの販売、ライセンス付与、貸与、または使用。
              <br />
              (f) 当サービスの他ユーザーのアクセス、使用または楽しみを妨害する行為に関わること。
              <br />
              (g) (i)
              違法、有害、脅迫的、虐待的、嫌がらせ、不法行為、極端に暴力的、中傷的、低俗、猥褻、下品、ポルノ、中傷的、他者のプライバシー（住所、電子メール、電話番号、その他の連絡先など）への侵襲、人種差別、民族差別である、(ii)
              法、契約、信託関係において送信する権利がない、(iii)
              誰かにとってプライバシーまたはセキュリティのリスクを課すまたは作り出す、(iv)
              他者の知的財産権または他の所有権を侵害する、(v)
              依頼していないまたは無許可の広告、プロモーション素材、商業活動および/または販売、「迷惑メール」、「スパム」、「チェーンレター」、「ネズミ講式販売」、「コンテスト」、「賞金レース」またはその他の形態の要求を成す、(vi)
              コンピュータソフトウェアまたはハードウェアまたは電気通信装置の機能を中断、破壊、制限するように作られたソフトウェアウイルスまたは他のコンピュータコード、ファイルまたはプログラムを含む、(vii)
              GlobalEnglishの単独の判断で、他者が当サービスを使用または楽しむことを邪魔/制限/禁止するものである、もしくはGlobalEnglishまたはそのユーザーを害または何らかの不利益にさらすユーザーコンテンツを投稿、メールまたは送信。
              <br />
              (h)
              偽の身元情報の作成、あなたの身元情報を偽る、人または組織を演じる、もしくは人または組織とあなたとの関係を偽って述べるまたは示すこと。
              <br />
              (i) 18歳未満の人への個人情報の要求。
              <br />
              (j) 何らかの方法で未成年者に害を与えること。
              <br />
              (k)
              グループや個人に対して身体的に危害を加えるまたは怪我させるように仕向ける、誰かへの「ストーキング」または嫌がらせ。
              <br />
              (l)
              爆弾、手りゅう弾、その他武器または発火装置の組立て方法について指示などの、違法行為についての指示情報の提供または促進。
              <br />
              (m)
              ユーザーに迷惑メールまたは一方的に通信物を送る、または当ウェブサイトの内容を複製する目的を含むがこれに限定されない、何らかの目的のための当ウェブサイトのコンテンツまたは電子メールアドレス、連絡先または他の個人情報を自動スクリプトなどを使った収集。
              <br />
              (n) 特に許可を得ていない事業目的で品物またはサービスの売買についての広告または提供。
              <br />
              (o)
              当ウェブサイト、サーバー、当ウェブサイトに接続するネットワークへの干渉または中断、もしくは当ウェブサイトに接続するネットワークの要件、手続き、ポリシー、または規則違反。
              <br />
              (p)
              適用地方、州、国、国際法または法的効力を持つ規則への違反、犯罪活動または団体の促進、または違法活動についての指示情報の提供。
              <br /> (q)
              当ウェブサイトで意図的に利用可能にしていない、または提供していない手段で素材または情報を取得またはアクセスを試みること。
              <br />
              (r) セキュリティ機能の上書き、またはバイパス、またはアクセスコントロールの回避。または
              <br />
              (s)
              他のユーザーとレビューを取引する、またはサクラでレビューを書くなど、利害の対立を起こす、または当サービスの目的を弱体化させる方法での当サービスの使用。
            </span>
          </span>
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>8. 知的財産権 </b>
          <br />
          <br />
          <b>8.1 GlobalEnglishの知的財産権 </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            コンテンツと他の支援ソフトウェアを含む、当サービスのコンテンツ全体は、GlobalEnglishの所有物であり、そのライセンサーまたは下請業者は米国および国際著作権と他の知的財産法で保護されています。
            <br />
            <br />{' '}
            GlobalEnglishおよび/またはそのライセンサーまたは下記団体の書面の同意なしで当サービスの何らかの部分を複製、再配布、変更、発行することを厳しく禁じます。
            <br />
            <br />{' '}
            権限を持つユーザーは当サービスとコンテンツにアクセスおよび使用し、ユーザーがすべての著作権または他の所有物注記をコンテンツのコピーのすべてに維持する場合は、言語トレーニング目的でユーザーの個人的な使用のためにユーザーが適切にアクセスしたコンテンツの一部の合理的な枚数のコピーをダウンロードまたは印刷できます。
            <br />
            <br />
            特記しない限り、当サービスに表示される商標は、GlobalEnglish、そのライセンサーまたは関連会社の商標です。あなたは、当社の商標を表示しない、軽んじない、または損なわない、もしくは紛らわしい類似証票を使わないこと、または商標の所有者を偽るように使わない、またはそのような印象を与えないことに同意します。あなたはGlobalEnglishの商標、商号および/またはトレードドレスを、GlobalEnglishの事前の書面による許可がなければ複製または使用することはできません。GlobalEnglishの商標使用によリ発生する金銭は当社が独占的に取得します。
            <br />
            <br />{' '}
            当ウェブサイト、アプリケーションまたはここに特に許可を与えているもの以外のコンテンツの使用は禁止されており、これを行うと、ここで与えられた当サービスとコンテンツの使用に関するあなたの権利は自動的に終了します。GlobalEnglishまたはそのライセンサーのすべての権利は本契約に自動的に付与されるものではなく、GlobalEnglishとそのライセンサーが留保します。
          </span>
          <br />
          <br />
          <b>8.2 第三者の商標 </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            当ウェブサイトで使用および表示される製品およびサービス名とロゴは、上記に記載のGlobalEnglishの商標以外のものは、承認したまたはしていない、またはGlobalEnglishの子会社または関係している各オーナーの商標またはサービスマークの場合があります。本契約または当ウェブサイトには、各事例において書面の事前許可を得ている場合を除き、商標の使用許諾ライセンスまたは権利を、暗示的、または禁反言により授与するものとは解釈されません。GlobalEnglishの商標使用によリ発生する金銭は当社が独占的に取得します。
          </span>
          <br />
          <br />
          <b>8.3 デジタルミレニアム著作権法における著作権苦情 </b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            他者が当サービスに投稿した素材について著作権上の問題がある場合は、当社にお知らせください。
            <br />
            <br />{' '}
            GlobalEnglishは、侵害疑義の通知を処理および調査し、疑われるおよび実際の侵害についてデジタルミレニアム著作権法（「DMCA」）ならびに他の適用知的財産法のもと適切な対応を取ります。
            <br />
            <br />
            著作権侵害の苦情通知はGlobalEnglishのCopyright
            Agent（アドレス：copyright@globalenglish.com）へメールしてください。 （件名：「DMCA削除リクエスト」）
            <br />
            <br /> 郵便で次に連絡することも可能です。
            <br />
            <b>宛先：Copyright Complaints/Legal Department（著作権苦情/法務部） </b>
            <br /> 1875 South Grant Street, Suite 700
            <br /> San Mateo, CA 94402 USA
            <br />
            <br />
            <br /> 有効に処理されるように、通知には次の情報を含めてください。(I)
            著作権または知的財産権利害の所有者の代理で行う権限を与えられた人の電子または物理的署名、(ii)
            あなたが侵害していると申し立てる著作権のある作品または他の知的財産の説明、(iii)
            あなたが侵害していると申し立てる素材が当サービスのどこにあるのかの説明を、当社が当ウェブサイトで見つけやすいように十分な詳細とともに、(iv)
            GlobalEnglishがあなたに連絡するための十分な情報（住所、電話番号、およびメールアドレス）、(v)
            使用が著作権または知的財産権所有者、団体、または法律の許可を得たものでないということを確信をもって断言するあなたの声明、(vi)
            不実記載における罰則および偽証罪の適用に関する事項を確認の上、あなたの通知にある情報は正確であなたが著作権または知的財産権所有者であるか著作権または知的財産権所有者の代理人であるという、あなたの声明。
            <br />
            <br />{' '}
            DMCAと他の適用法に従って、GlobalEnglishは該当する状況においてGlobalEnglishの単独の裁量で、繰り返し侵害するものと見なされたユーザーの契約を解除するポリシーを採用しました。GlobalEnglishはまた、その単独の裁量で、繰り返しであるなしに関わらず、他者の知的財産権を侵害するユーザーのウェブサイトへのアクセスを制限、および/またはメンバーシップを解除します。
          </span>
          <br />
          <br />
          <b>8.4 侵害の恐れがあるユーザーコンテンツの削除</b>
          <br />
          <span style={{ paddingLeft: '18px', display: 'inline-block' }}>
            GlobalEnglishが第三者の知的財産権に侵害する恐れがあるあなたのユーザーコンテンツを削除し、あなたは削除された（またはアクセスできなくなった）自分のユーザーコンテンツは侵害するものでないと思う場合、または著作権所有者、著作権所有者の代理人、または法に関してあなたのユーザーコンテンツ内で投稿しそのコンテンツを使用する許可を得ている場合、次の情報を含む反論通知をCopyright
            Agentへお送りいただくことができます：(i) あなたの電子または物理的署名、(ii)
            削除されたまたはアクセスできなくなったコンテンツを識別するための情報と削除/無効化前にコンテンツがあった場所、(iii)
            間違いまたはコンテンツの間違った識別によりコンテンツが削除/無効化されたということを確信をもって断言するあなたの声明、(iv)
            あなたの住所、電話番号、およびメールアドレス、Northern District of
            Californiaにある連邦裁判所を司法管轄にすることの同意と、侵害疑義に基づいて通知を行った者による処理業務を受け入れる旨のあなたの声明。{' '}
            <br />
            <br /> Copyright
            Agentが反論通知を受信すると、GlobalEnglishは削除されたコンテンツを復元したまたは無効化を停止する旨を告げる反論通知の複写を元の侵害申し立て者に10日以内に送付します。著作権所有者がコンテンツ提供者、メンバーまたはユーザーに対して法的訴訟を行わない限り、当社独自の裁量で、反論通知の受信後10～14営業日前後でコンテンツが復元されるか、アクセス可能になります。
          </span>
          <br />
          <br />
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}> 9. 国際的な使用および輸出管理 </b>
          <br />
          <br />{' '}
          インターネットがグローバル化しているため、あなたは、オンライン行為と許容可能なユーザーコンテンツに関するすべての地域の規則を順守することに合意します。あなたは、米国またはあなたの居住国から輸出される技術データの送信に関して、すべての適用法を順守することに合意します。
          <br />
          <br />{' '}
          あなたは、当サービスまたはその一部が米国の輸出管理法の対象となる可能性について認識します。あなたは、当サービスのいかなる部分も、または関連技術情報または素材を、適用輸出法または規則を違反して、直接的または間接的に輸出、再輸出または移送しません。あなたは、米国政府の禁輸国または米国政府が「テロリスト支援」国として指定された国の国民ではなく、そこへ居住しておらず、米国政府の禁止リストまたは制限団体に記載されていないことを表明し保証します。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>10. 差し止めによる救済 </b>
          <br />
          <br />{' '}
          あなたは、使用条件に反して当サービスを使用することで、GlobalEnglish、その関連会社、ライセンサー、委託先、再販業者、およびユーザーに取り返しのつかない損害を与える場合があることを認識しています。かかる状況下で、GlobalEnglish、その関連会社、ライセンサー、委託先、再販業者、およびユーザーには、保証金の供託を義務付けられることなく、一時的または永久的な損害救済を含むがこれに限定されない、差し止めおよびその他公正とされる救済措置が認められます。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>11. 中断時間 </b>
          <br />
          <br />{' '}
          当サービスは時折メンテナンスなどの理由で一時的に利用できなくなる場合があります。GlobalEnglishは、ウェブサイトにより利用可能なユーザー通信または他のコンテンツの中断、操作または送信の遅延、盗難または破壊、不正なアクセス、変更に一切責任を負いません。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>12. 保証の免責</b>
          <br />
          <br />{' '}
          当サービスは時折メンテナンスなどの理由で一時的に利用できなくなる場合があります。GlobalEnglishは、当サービスにより利用可能なユーザー通信または他のコンテンツの中断、操作または送信の遅延、盗難または破壊、不正なアクセス、変更に一切責任を負いません。どのような状況であっても、GlobalEnglishは、当サービス、ユーザーコンテンツ、または第三者のコンテンツの使用、またはユーザーが提供した製品またはサービスの使用による個人の怪我または死亡について責任を負いません。
          <br />
          <br /> あなたは次を理解し同意します：
          <br />
          <br />
          <span style={{ padding: '0 2% 0 2%', display: 'inline-block' }}>
            {' '}
            (a) コンテンツを含む当サービスは、「現状」で、かつ利用可能なものが提供されます。
            <br />
            <br /> (b)
            GlobalEnglishは、明示もしくは黙示を問わず、当サービスに関して、権利、商業性、特定目的への適合性、非侵害の黙示的な保証を含む、一切の責任および保証を放棄します。
            <br />
            <br /> (c)
            GlobalEnglishは、当サービスの使用による特定の結果や当サービスがあなたの要件や期待を満たさなかったことについて保証も約束もしません。
            <br />
            <br />
            (d)
            GlobalEnglishは、当サービス内のまたは当ウェブサイトのソフトウェア、コンテンツ、または素材が正確、完全、信頼性がある、現在のまたは間違いがないものであるということ、または当ウェブサイトまたはサービス、またはサーバーにウイルスまたは有害なコンポーネントがないことを表明も保証もしません。従って、上記を制限することなく、あなたは次を理解し同意します：あなたはあなたの裁量とリスクでサービスから、またはプロバイダーからコンテンツ、素材、データまたはソフトウェアをダウンロードまたは取得し、それらの使用とあなたのコンピュータシステムへの損傷、データの損失、またはこの結果による何らかの危害についてあなたが単独で責任を負います。
            <br />
            <br /> (e) GlobalEnglishは、当サービスにあるエラーや不良の修正について保証しません。
            <br />
            <br />
            (f)
            GlobalEnglishは、ユーザーの行為、第三者のコンテンツ、ならびにユーザーコンテンツについて責任を負いません。
            <br />
            <br />
            (g)
            当サービスは時折メンテナンスなどの理由で一時的に利用できなくなる場合があります。GlobalEnglishは、当サービスにより利用可能なユーザー通信または他のコンテンツの中断、操作または送信の遅延、盗難または破壊、不正なアクセス、変更に一切責任を負いません。どのような状況であっても、GlobalEnglishは、当サービス、ユーザーコンテンツ、または第三者のコンテンツの使用、またはユーザーが提供した製品またはサービスの使用による個人の怪我または死亡について責任を負いません。
          </span>
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>13. 責任制限</b>
          <br />
          <br />{' '}
          いかなる場合でも、GlobalEnglishまたはその取締役、従業員、代理人、ライセンサー、下請業者は、次のことから派生した利益損失またはデータ損失などに関して、あなたまたは第三者に直接的、偶発的、結果的、間接的または懲罰的な責任を負いません：(I)
          あなたの当サービス、またはコンテンツ、または当ウェブサイト、サービス、またはプロバイダーからアクセスしたまたはダウンロードした他の素材が使用または使用できないこと、(II)
          品物、データ、情報、またはサービスの購入または取得した結果による、品物またはサービスの代替品を調達する費用、またはウェブサイト経由で受送信されたメッセージ
          (III) 何者かによる不正なアクセスまたはあなたの送信物またはデータの変更、(IV)
          当ウェブサイトにおける何者かの声明または行為、または(V)
          当サービスに関するその他の問題。あなたがGlobalEnglishに過去十二（12）ヶ月以内に支払った総額を超える、または百（100）ドルを超えるすべての損害、損失または訴訟について、GlobalEnglishがかかる損害の可能性について気付いていた、または知らせを受けていたとしても、GlobalEnglishはいかなる場合も責任を負うことはありません。以下の申し立てが2つ以上あったとしても、この制限を増やすことにはなりません。
          <br />
          <br />{' '}
          司法管轄によっては偶発的または結果的な損害の一定の保証の除外または責任の制限または除外を認めていないところもあります。従って、上述の制限の一部はあなたに適用されない可能性があります。
          <br />
          <br />{' '}
          当ウェブサイトまたはウェブサイトの本契約について不服がある場合、あなたの唯一かつ排他的な救済は当ウェブサイトの使用をやめることです。
          <br />
          <br />{' '}
          どのような状況であっても、GlobalEnglishは、当サービス、ユーザーコンテンツ、または第三者のコンテンツの使用による個人の怪我または死亡について責任を負いません。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>14. 公訴時効 </b>
          <br />
          <br />
          あなたは、いかなる法規または法律の規定にかかわらず、サービスの使用から生じるGlobalEnglishに対する申し立てまたは訴訟原因は、当該の申し立てまたは訴訟原因の発生後、一（1）年以内に提訴されなければならず、その期間を過ぎた後の提訴は永久に禁じられることに同意します。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>15. 損害賠償</b>
          <br />
          <br />
          あなたは、GlobalEnglish、その関連会社と役員、従業員、取締役、代理人を、あなたが当ウェブサイト、サービス、あなたのユーザーコンテンツ、あなたの当ウェブサイトまたはサービスへの接続、あなたの本契約違反、またはあなたの他のユーザーの権利または法律違反、またはサービスの使用以外で生じた事項から生じた、または関係する第三者からGlobalEnglishに対してなされたすべての賠償請求、法的措置、費用、負債、損害、合理的な弁護士費用を含む経費から解放、免責、補償し、かつ無害に保つことに同意します。あなたの損害賠償責任には、ユーザーコンテンツが第三者の知的財産権を侵害しているというGlobalEnglishに対する申し立てが含まれますが、これらに限定されません。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>16. 契約の解除 </b>
          <br />
          <br />{' '}
          あなたの購読が何らかの理由で解除される際、GlobalEnglishはあなたが当サービスにアクセスできないようにします。あなたはご自身のユーザーコンテンツを含む、すべてのコンテンツにアクセスできなくなりますが、かかるデータの複写がバックアップのため当社システムに三（3）年間残されます。
          <br />
          <br />{' '}
          あなたがGlobalEnglishにあなたの個人データとユーザーコンテンツを削除するようリクエストした場合、これを行うための合理的な努力をし、削除されたことを確認します。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>17.権利放棄および分離性 </b>
          <br />
          <br />{' '}
          GlobalEnglishが本契約の権利または規定を行使または実行しなかった場合でも、その結果かかる権利または規定を放棄するものではありません。本契約の規定が、不法であったり無効であったり適用不可能であることが分かった場合、他の残りの規定の有効性と執行可能性に影響を与えることはありません。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>18. 完全な合意 </b>
          <br />
          <br />{' '}
          本契約はサービスの使用に関してあなたとGlobalEnglish間の完全な合意を構成するもので、当サービスの使用に関してあなたとGlobalEnglish間の全ての合意または了解事項に優先します。
          <br />
          <br />{' '}
          上記にかかわらず、あなたの会社にサービス購入に関するGlobalEnglishとの既存の契約がある場合、本契約はあなたの会社がGlobalEnglish、その子会社または関連会社と締結した契約の規定または条件を変えることを意図しておらず、矛盾する場合は、既存契約が優先されます。
          <br />
          <br />{' '}
          本契約は英語で作成されており、このバージョンがすべての面において管理され、英語以外のバージョンは本契約を適応する目的のみのものです。本契約書および電子的形式で行われたあらゆる通知を印刷物とした版は、当初から印刷された形式で作成および保管されてきたその他の業務文書および記録がもつのと同じ範囲および同じ条件で、本契約書に基づくまたは本契約書に関する訴訟手続または行政手続において、証拠能力を持つものとします。本契約のセクションタイトル便宜を図るためにつけられたもので、法的または契約上の効力はありません。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>19. 法、フォーラム、仲裁の選択 </b>
          <br />
          <br />
          本契約は、カリフォルニア州法に従って同法の規則と軋轢を生じることなしに管轄されます。
          <br />
          <br />{' '}
          GlobalEnglishの選出とその単独の裁量で、相互の同意により解決されなかった本契約またはウェブサイトから生じたまたはこれに関係するすべての紛争、申し立て、論争は、JAMSまたはその後継者の前で行う拘束力を持つ仲裁で解決する場合があります。両当事者の合意がない限り、仲裁はカリフォルニア州サンフランシスコで両当事者が相互に合意した単独の仲裁人の前で行われるか、両当事者が相互に合意しない場合は、JAMSが指定した単独の仲裁人の前で行われ、本契約で特に変更のない限り、JAMSが制定した規則および規定に従って行われます。仲裁はいずれかの当事者が仲裁の書面での要求が行われた日付から四十五（45）日以内に始める必要があります。仲裁人の決定および裁定は、仲裁の終了の六十（60）日以内かつ仲裁人の選定の六（6）ケ月以内に行い届けるものとします。仲裁人は、実際の損害、本契約に記載の直接的な損害における限度を超える損害の裁定をくだす権限はなく、実際の損害の範囲を広げることや懲罰的損害賠償を裁定することはできず、各当事者はここにかかる損害に対する請求を取消不能で放棄します。仲裁人は、彼/彼女の裁量で、当事者に対して手続きのための費用および経費（合理的な法的料金および一般的な費用）を査定します。仲裁人の命令を守ることを拒否する当事者があれば、裁定を実施する際に他方にかかった弁護士料を含む費用および経費の責任を負うことになります。上記にかかわらず、一時的および恒久的な差し止めによる救済の場合、いずれの当事者も直接的かつ回復し難い損害を避けるために、事前の仲裁なしで法的て続けを進めることができます。本仲裁部分の条項は、管轄を有するいずれの裁判所においても執行が可能となります。
          <br />
          <br />{' '}
          仲裁の対象ではない論争や請求に関して、上記のとおり、あなたとGlobalEnglishは個人およびカリフォルニア州サンフランシスコ群にある州立裁判所および連邦裁判所の専属管轄に従うことに同意します。
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '12px', fontFamily: '"calibri"' }}>20. 通知および契約 </b>
          <br />
          <br />
          <a href="https://support.globalenglish.com/" rel="noopener noreferrer" target="_blank">
            https://support.globalenglish.com/
          </a>{' '}
          の「連絡先（Contact
          Us）」フォームリンクから契約解除通知をGlobalEnglishにお送りいただけば、GlobalEnglishアカウントの解除を申し出ることができます。あなたのアカウントを解除した後はいつでもGlobalEnglishがこちらのコンテンツを含む、当サービスへのアクセスと使用ができないようにします。
          <br />
          <br />{' '}
          あなたへの通知はメールまたは郵送によって行います。当ウェブサイトはまた、本契約の変更または他の事項について通常当サービスへ通知またはリンクを表示することによって、あなたに通知を行います。
          <br />
          <br /> 当社のプライバシーポリシーに関する通知は、
          <a href="mailto:privacy@globalenglish.com" rel="noopener noreferrer" target="_blank">
            privacy@globalenglish.com
          </a>
          へお送りください。
          <br />
          <br /> 他の法的通知またはGlobalEnglishへの返答は、次の電子メールアドレスまでお送りください。
          <a href="mailto:legal@globalenglish.com" rel="noopener noreferrer" target="_blank">
            legal@globalenglish.com
          </a>{' '}
          または次の郵送先へ。
          <br />
          <br /> 1875 S Grant Street, Suite 700
          <br /> San Mateo, CA 94402
          <br />
          <b>Legal Counsel</b>宛て
          <br />
        </p>
        <p style={{ fontSize: '14px', fontFamily: '"calibri"', textAlign: 'center', width: '100%' }}>
          <b>B2Bトランザクション用特定条件 </b>
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          {' '}
          あなたのGlobalEnglishのアカウントを雇用主が取得した場合、あなたが当サービスを使用することはあなたの会社（「会社」）との契約も対象となります。使用条件はあなたの会社との契約条件を変えることを意図したものではありません。あなたの会社があなたにGlobalEnglishのライセンス上のエンドユーザーとしてあなたを許可しない場合は、当サービスを使う（または使い続ける）ことはできません。当社にアカウント解除を申し出られる場合、GlobalEnglishがあなたのアカウントを解除する前にあなたの会社に許可を求められる可能性があります。
          <br />
          <br />{' '}
          あなたは、あなたの会社が許可した場合にのみ当サービスを使用することに同意します。あなたはあなたの会社内の誰かとやり取りし、または当サービスを介してあなたの会社に関する文書をアップロードする機会が持てますが、あなたの会社の許可なしでこれを行うことは許されておらず、してはなりません。
          <br />
          <br />{' '}
          あなたは、あなたの当サービスの使用に関して発生したすべてのデータ（「ユーザーのデータ」）にあなたの会社はアクセスすることができ、このためGlobalEnglishはあなたが当サービスを使用した結果あなたの会社と共有された情報について、あなたに一切責任を負わないことを認識し合意します。
          <br />
          <br />
          当サービスへアクセスするあなたの購読は会社のライセンス条件に対してのみ継続するため、あなたの会社がGlobalEnglishとのライセンス契約を修了した場合は、あなたは当サービスとユーザーコンテンツにアクセスできなくなります。次の場合、GlobalEnglishは、あなたの会社のアカウント、あなたのアカウントまたは当サービスを使用する機能の全部または一部を、通知なしで解除または保留する場合があります：
          (i) あなたの会社がGlobalEnglishへの料金支払いを支払い日までに行わなかった、または (ii)
          あなたまたはあなたの会社が本契約に違反する、または当サービスの使用に適用される他の規則に違反する場合。
          <br />
          <br />{' '}
          GlobalEnglishは、あなたの個人データとユーザーコンテンツを含むあなたの当サービスの使用に関するすべてのデータをあなたの会社に返却する義務を負う場合があります。あなたの会社がかかるデータの返却または消去を要求しない場合、GlobalEnglishはあなたの雇用主との契約の期限切れまたは解除から三（3）年の機関データを維持するものとします。この場合、あなたはGlobalEnglishから直接サービスの購読を行い進捗情報を失うことなくプログラムへのアクセスを続けることができます。あなたはご自身の進捗とプロフィール情報をあなたの新しい雇用主による新規購読へ移送する権利を持てます。また、将来的なインポートに対応する書式であなたのサービスの使用に関するすべてのデータをリクエストすることもできます。
        </p>
        <p style={{ fontSize: '14px', fontFamily: '"calibri"', textAlign: 'center', width: '100%' }}>
          <b>B2Cトランザクション用特定条件 </b>
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          あなたはまた、個人としてGlobalEnglishと三（3）または六（6）ヶ月の購読、または一年または複数年の購読プラン（それぞれ「購読プラン」）からなる購読契約を結ぶこともできます。
          <br />
          <br />{' '}
          該当する購読プランの請求を、あなたの購読プランを取り消すまで、毎月/年（該当する場合）の同じ日の前後に、毎月または毎年受け取ることになります。誤解を避けるために、あなたが選んだ当サービスを取消す、シート数を減らす、またはグレードを下げることは、購読プランの年度切替時まではできないことにご注意ください。購読プラン支払いは返金されません。
          <br />
          <br />{' '}
          当サービスに適用される料金（「料金」）は、当ウェブサイトおよび/またはGlobalEnglishで確認できる、それから価格表として発行します。記載のサービス料金には、特記のない限りは、税および手数料は含まれていません。あなたは、当サービスを使用するための税および手数料がある場合は（例えば、データ手数料や両替手数料）これを支払います。あなたは、自分のアカウントに対してGlobalEnglishが見積もりした通貨で料金を支払います。GlobalEnglishは、いつでも見積もり通貨を変更する権利を留保します。
          <br />
          <br />
          <b style={{ fontSize: '14px', fontFamily: '"calibri"' }}> 支払い </b>
          <br />
          <br />{' '}
          支払いは購読ライセンスの購入時に行っていただきます。お支払いにはPayPalおよびStripeをご利用いただけます。あなたがサービスプロバイダに提供したクレジットカード情報や他の支払い方法の情報を当社が受信したり処理したりすることはありません。
          <br />
          <br />{' '}
          すべてのサービスが選択した期間（月、年）に対して前払いで返金不可です。リニューアルしたアカウントに対しても同様です。
          <br />
          <br /> -----
        </p>
        <p style={{ fontSize: '12px', fontFamily: '"calibri"' }}>
          <b style={{ fontSize: '14px', fontFamily: '"calibri"' }}>カリフォルニア州のユーザーへのお知らせ </b>
          <br />
          <br />
          あなたがカリフォルニア州民であれば、California Civil Code Section
          1789.3により、第三者のダイレクトマーケティングのためにあなたの個人データを第三者へ提供することに関する情報開示をリクエストできます。2021年に施行されるCalifornia
          Consumer Privacy Act（Civil Code Section 1798.100 to 1709.198）では、あなたに次の特定の権利があります。
          <br />
          <br />
          <span style={{ padding: '0 2% 0 2%', display: 'inline-block' }}>
            (a)あなたについてどの個人データが収集され複写が受け取られたかを知る権利、
            <br />
            <br />
            (b) 削除する権利、
            <br />
            <br />
            (c) あなたの個人データがどの第三者へ販売されたかを知る権利とかかる販売をやめるようリクエストする権利、および
            <br />
            <br />
            (d) あなたが消費者の権利を行使した際に差別されない権利。
          </span>
          <br /> また、California Business and Profession Code Section
          22581により、現在カリフォルニア州の未成年者がウェブサイトに公開で投稿したコンテンツを削除するようリクエストできます。しかしながらGlobalEnglishにはあなたの投稿したコンテンツが完全または包括的に削除できたかは確認できず、また状況によってはリクエストがあったとしても法的にこれができない場合もあることにご注意ください。
          <br />
          <br />
          あなたの権利を行使するリクエストをしたい場合：
          <br />
          <br /> ウェブサイトと関連サービスのプロバイダーはGlobalEnglish Corporation,で、所在地は1875 South Grant
          Street, Suite 700, San Mateo, CA 94402, USAです。メールアドレス：privacy@globalenglish.com.
          <br /> 本契約の日付時点で、当ウェブサイトによる消費者への直接的な費用は課せられていません。
          当ウェブサイトで提供されているサービスに苦情がある場合、または詳細をお求めの場合、あなたのご希望内容をお書きの上、上記の所在地へ郵送してください。特定の時間内に返答するという保証はできません。まだご不満がある場合は、California
          Department of Consumer AffairsのDivision of Consumer ServicesのComplaint Assistance
          Unitに書面またはお電話にてご連絡いただけます。宛先：1625 North Market Blvd., Suite N 112, Sacramento, CA
          95834、電話番号： (916) 445-1254 / (800) 952-5210。
        </p>
      </div>
    </div>
  );
}

export default JaJpContent;
